import React from 'react';

import {
  FaFileInvoice,
  FaUsers,
  FaHandHoldingUsd,
  FaFileInvoiceDollar,
  FaRegFileExcel,
  FaSignOutAlt,
  FaStoreAlt,
  FaIdBadge,
  FaWhatsapp,
} from 'react-icons/fa';
import { ImTarget } from 'react-icons/im';
import { MdReplay } from 'react-icons/md';

import { BpmIcon } from 'assets/BpmIcon';
import { CRMIcon } from 'assets/CRMIcon';
import { GedIcon } from 'assets/GedIcon';
import { PdvIcon } from 'assets/PdvIcon';
import BillsIcon from 'components/atoms/BillsIcon';
import MarketingIcon from 'components/atoms/CRMIcon';
import EmployeesIcon from 'components/atoms/EmployeesIcon';
import ForgotPasswordIcon from 'components/atoms/ForgotPasswordIcon';
import GoalsIcon from 'components/atoms/GoalsIcon';
import LoanIcon from 'components/atoms/LoanIcon';
import RepaymentIcon from 'components/atoms/RepaymentIcon';
import StoreIcon from 'components/atoms/StoreIcon';
import TypeLoanIcon from 'components/atoms/TypeLoanIcon';
import ZekiIcon from 'components/atoms/ZekiIcon';
import { IconContext } from 'components/IconContext';
import { theme } from 'styles';
import { PermissaoDescricao } from 'types/graphql';

export const NavbarProlifeLink = [
  {
    id: 1,
    name: 'Perfil',
    data: [
      {
        id: 1,
        name: 'Alterar Senha',
        url: '/dashboard/configuracoes/alterar-senha',
        icon: <IconContext icon={<ForgotPasswordIcon fill="#FFFFFF" height="26" width="26" />} className="icon" />,
      },
      {
        id: 2,
        name: 'Sair',
        url: '/dashboard',
        icon: <IconContext icon={<FaSignOutAlt color="#FFFFFF" />} size={'24'} className="icon" />,
      },
    ],
  },
];

export const NavBarMobileLink = [
  {
    id: 1,
    name: 'PDV',
    icon: (
      <IconContext
        icon={<GedIcon fill={theme.palette.primary.main} height="24" width="25" />}
        className="icon"
        size="24"
      />
    ),
    data: [
      {
        id: 1,
        name: 'Clientes',
        url: '/dashboard/clientes',
        icon: <IconContext icon={<FaUsers color="#FFFFFF" />} size={'24'} className="icon" />,
        permissions: [PermissaoDescricao.VerCliente],
      },
      {
        id: 2,
        name: 'Empréstimos',
        url: '/dashboard/emprestimos',
        icon: <IconContext icon={<LoanIcon fill={'#FFFFFF'} height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerEmprestimo, PermissaoDescricao.VerEmprestimoPorTipo],
      },
      {
        id: 3,
        name: 'Relatórios',
        url: '/dashboard/relatorios',
        icon: <IconContext icon={<FaRegFileExcel color="#FFFFFF" />} size={'24'} className="icon" />,
        permissions: [PermissaoDescricao.FechamentoCaixaRelatorio, PermissaoDescricao.EmprestimoClienteRelatorio],
      },
    ],
  },

  {
    id: 2,
    name: 'Finanças',
    icon: <IconContext icon={<BpmIcon fill={theme.palette.primary.main} height="24" width="24" />} />,
    data: [
      {
        id: 1,
        name: 'Contas a Pagar',
        url: '/dashboard/contas-pagar',
        icon: <IconContext icon={<BillsIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerContaPagar],
      },
      {
        id: 2,
        name: 'Reembolsos',
        url: '/dashboard/reembolsos',
        icon: <IconContext icon={<RepaymentIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerPedidoReembolso],
      },
    ],
  },

  {
    id: 3,
    name: 'Gestão',
    icon: <IconContext icon={<PdvIcon fill={theme.palette.primary.main} height="24" width="24" />} className="icon" />,
    data: [
      {
        id: 1,
        name: 'Lojas',
        url: '/dashboard/lojas',
        icon: <IconContext icon={<StoreIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerEntidade],
      },
      {
        id: 2,
        name: 'Funcionários',
        url: '/dashboard/funcionarios',
        icon: <IconContext icon={<EmployeesIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerFuncionario],
      },
      {
        id: 3,
        name: 'Metas',
        url: '/dashboard/metas',
        icon: <IconContext icon={<GoalsIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerMeta],
      },
      {
        id: 4,
        name: 'Tipos de Empréstimo',
        url: '/dashboard/tipos-emprestimo',
        icon: <IconContext icon={<TypeLoanIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerTipoEmprestimo],
      },
    ],
  },

  {
    id: 4,
    name: 'Marketing',
    icon: <IconContext icon={<CRMIcon fill={theme.palette.primary.main} height="24" width="24" />} className="icon" />,
    data: [
      {
        id: 1,
        name: 'CRM',
        url: '/dashboard/crm',
        icon: <IconContext icon={<MarketingIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerLeads],
      },
      {
        id: 2,
        name: 'Zeki',
        url: '/dashboard/zeki-bot',
        icon: <IconContext icon={<ZekiIcon fill="#FFFFFF" height="24" width="24" />} className="icon" />,
        permissions: [PermissaoDescricao.VerBotZeki],
      },
    ],
  },
];
